import { useRef, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

export default function TrainingTimelineSettings({
    displaySettingsOptions = []
}) {

    const displaySettingsMenuRef = useRef(null)

    const [showDisplaySettings, setShowDisplaySettings] = useState(false)

    const adminToolsVisible = useSelector((state) => state.user.adminToolsVisible)

    useEffect(() => {
        if (!showDisplaySettings) {
            return
        }

        const HandleClickOutside = (event) => {
            if (displaySettingsMenuRef.current && !displaySettingsMenuRef.current.contains(event.target)) {
                setShowDisplaySettings(false)
            }
        }

        document.addEventListener('mousedown', HandleClickOutside)

        return () => {
            document.removeEventListener('mousedown', HandleClickOutside)
        }
    }, [showDisplaySettings])

    if (!adminToolsVisible) return null

    return (
        <div
            ref={displaySettingsMenuRef}
            className='absolute top-0 right-0 z-50 flex flex-col items-end pl-4 pr-3 pt-2'
        >
            <button
                type='button'
                className='flex items-center rounded-md bg-white text-gray-600 hover:text-gray-900'
                onClick={() => setShowDisplaySettings((current) => !current)}
            >
                <span className='text-sm'>Settings</span>
            </button>

            {showDisplaySettings && (
                <div className='mt-1 w-52 rounded-md border border-gray-200 bg-white py-1 shadow-lg'>
                    {displaySettingsOptions.map((option) => (
                        <label
                            key={option.label}
                            className='flex cursor-pointer items-center gap-x-2.5 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50'
                        >
                            <input
                                type='checkbox'
                                className='h-3.5 w-3.5 rounded border-gray-300 text-orange-600 focus:ring-orange-500'
                                checked={option.checked}
                                onChange={(e) => option.setChecked(e.target.checked)}
                            />
                            <span>{option.label}</span>
                        </label>
                    ))}
                </div>
            )}
        </div>
    )
}